export default __webpack_public_path__ + "static/media/speedkino_policy.e60eda22.png";